export const OrderFilters = {
    SET_IN_SYNC: 'IN_MEMORY.ORDER.IN_SYNC',
};

export const setInSync = inSync => ({
    type: OrderFilters.SET_IN_SYNC,
    inSync
})